module.exports = __webpack_public_path__ + "img/blueDelete1.0be67f94.svg";